<template>
    
    <div class="">
        <div v-if="showChoice" class="has-text-centered">
            
            <label class="pb-3">{{ config.title }}</label>

            <div class="columns is-mobile mt-0">

                <div class="column is-half has-text-right">
                    <button v-on:click="selectCamera()" class="button is-light"><i class="fa-solid fa-camera"></i></button>
                </div>

                <div v-if="config.canUpload" class="column is-half has-text-left">
                    <button v-on:click="selectUpload()" class="button is-light"><i class="fa-solid fa-upload"></i></button>
                </div>
            </div>
        </div>
        
        <div v-if="showCamera" class="video">
            <scanner v-if="config.readCodes" @saveCode="saveCode"></scanner>
            <camera v-else @send-picture="receivedEmitCamera" @barcode-scanned="onBarcodeScanned"> </camera>
        </div>
        
        <hr :style="{ visibility:  brVisibility}">
        
        <div v-if="!config.readCodes && !showChoice">
            <gallery v-bind:images="arrayPictures" v-bind:imgLimit="parseInt(this.config.imgLimit)" @exceeded-limit="exceededLimit" @remove-picture="removePicture"></gallery>
        </div>
        
        <div class="columns is-mobile" style="margin-bottom: 15px; margin-top: 25px;">
            <div class="column is-4" v-show="!showChoice">
                <button class="button" v-on:click="cancel()" >
                    <span class="icon is-small"><i class="fas fa-trash"></i></span>
                    <span>Close</span>
                </button>
            </div>
            
            <div class="column">
                <uploader v-if="showUpload" :current-count="arrayPictures.length" @files-uploaded="handleFileUpload" class="upload"></uploader>
            </div>
            <div class="column" v-if="arrayPictures.length>0">
                <button class="button is-link rightButton" v-on:click="sendPictures()">Confirm</button>
            </div>
        </div>
        
        <bulmaModal v-on:click="modalClick" v-if="showMessage" v-bind:title="'confirm'">
            <p class="is-size-5">{{ modalMessage }}</p>
        </bulmaModal>
        
    </div>
    
    <!-- pictures (props: arrayPhoto, limit) -->
</template>

<script> 
import camera from './bulma_camera.vue';
import scanner from './bulma_camera2.vue';
import gallery from './bulma_pictures.vue';
import uploader from './bulma_pictureupload.vue';

export default {
    name: 'bulmaPicturesManager',
    props:{
        id: String
    },
    components:{
        camera,
        scanner,
        gallery,
        uploader,
    },
    data() {
        return{
            arrayPictures: [],
            modalMessage: "unpopulated",
            showMessage: false,
            modalUse: -1,
            showCamera: false,
            showUpload: false,
            showChoice: true,
        }
    },
    computed:{
        config: function () {
            if (this.$store.getters.getObject(this.id)){
                console.log(JSON.stringify(this.$store.getters.getObject(this.id).data), "test data")
                return this.$store.getters.getObject(this.id).data;
            }else {
                console.log("no id for config")
                return {}
            }
        },
        brVisibility: function(){
            // console.log( "brVisibility --> ", (!this.showCamera && !this.showUpload) || this.showCamera);
            return (!this.showCamera && !this.showUpload) || this.showUpload ? 'hidden' : 'visible';
        }
    },
    methods:{
        saveCode(e) {
            this.$emit('send-pictures', e)
        },
        receivedEmitCamera(data){
            // console.log("emit simulato", this.config.imgLimit)
            //emit da camera
            this.arrayPictures.push(data.picture);
        },
        
        removePicture(data){
            //emit da pictures
            this.arrayPictures.splice(data.index, 1);
        },
        
        exceededLimit(data){
            //emit da pictures
            this.arrayPictures = data.newPictures;
        },
        
        onBarcodeScanned(payload){
            console.log('barcode-scanned', payload)
            this.closeSelectedChoice();
        },

        sendPictures(){
            let accept = confirm("are you sure you want to save the images?");
            if(!accept) return;
            console.log("send")
            this.$emit('send-pictures', {pictures: this.arrayPictures});
            this.closeSelectedChoice();
        },
        
        cancel(){
            // let accept = confirm("are you sure you want to close and discard?");
            let accept = confirm(this.config.messaggioChiusura);
            if(!accept) return;
            console.log("cancel")
            
            this.closeSelectedChoice();
            
            this.$emit('cancel', {});
        },
        
        handleFileUpload(files) {
            console.log(files);
            
            this.arrayPictures = this.arrayPictures.concat(files);
        },
        
        handleCameraPicture(data) {
            if (this.arrayPictures.length < this.config.imgLimit) {
                this.arrayPictures.push(data.picture)
            }
        },
        
        modalClick(click){
            console.log("click: ", click)
            if(click == -1 || click == 1){
                this.showMessage = false;
            }else if(click == 0){
                if(this.modalUse==1){
                    this.$emit('send-pictures', {pictures: this.arrayPictures});
                }else{
                    this.$emit('cancel', {});
                }
                
                this.showMessage = false;
                
            }
        },
        
        closeSelectedChoice() {
            this.showChoice = true;
            this.showCamera = false;
            this.showUpload = false;
            this.arrayPictures.splice(0, this.arrayPictures.length);
        },
        
        selectCamera(){
            this.showChoice = false;
            this.showCamera = true;
        },
        
        selectUpload(){
            this.showChoice = false;
            this.showUpload = true;
        },
        
    }
}
</script>

<style>
.upload{
    position: relative;
    right:0px;
    
}

@media (max-width: 480px) {
    .cancelButton{
        /* position: relative;
        margin-top:15% !important;
        left: 50%;
        top: 10vh; */
        
    }
    .rightButton{
        position: absolute;
        /* right: 5.5%; */
        right:5.2vw;
        
    }
    
    
}
@media (min-width: 480px) {
    .padre{
        width:65%;
        margin-left: 17.5%;
    }
    .rightButton{
        position: absolute;
        right: 18.5%;
        
    }
}

</style>